import dayjs from 'dayjs'
import { FiEye } from 'react-icons/fi'
import { formatString } from '../../../../utils'
import { getLatestStatus, getStatusLabel, getStatusBadgeClass, formatLocation } from '../utils'

const OrdersTable = ({ orders, isCactusAdmin, statusFilter, shippingFilter, error, onViewOrder }) => {
    if (error) {
        return (
            <div className="table-container">
                <div className="empty-state">
                    <div className="empty-state-title">Error Loading Orders</div>
                    <div className="empty-state-text">{error.message}</div>
                </div>
            </div>
        )
    }

    if (!orders.length) {
        return (
            <div className="table-container">
                <div className="empty-state">
                    <svg className="empty-state-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={1}
                            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                        />
                    </svg>
                    <div className="empty-state-title">No Custom Saddle Orders Found</div>
                    <div className="empty-state-text">
                        {statusFilter || shippingFilter
                            ? 'Try adjusting your filters to see more results.'
                            : 'Custom saddle order requests will appear here.'}
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="table-container">
            <div className="overflow-x-auto">
                <table className="custom-orders-table">
                    <thead>
                        <tr>
                            <th>Order ID</th>
                            <th>Horse Name</th>
                            <th>Manufacturer</th>
                            <th>Measurements</th>
                            <th>Saddle Specs</th>
                            <th>Location</th>
                            <th>Status</th>
                            <th>Date</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {orders.map((order) => {
                            const displayStatus = getLatestStatus(order)
                            return (
                                <tr key={order.id} onClick={() => onViewOrder(order)}>
                                    <td className="font-medium text-[#5C80B6]">
                                        {order.orderId}
                                    </td>
                                    <td className="font-semibold">{order.horseName}</td>
                                    <td className="text-[13px] text-gray-700">
                                        {formatString(order.manufacturerName) || 'N/A'}
                                    </td>
                                    <td>
                                        <div className="flex flex-col gap-1">
                                            <span className="text-[12px]">
                                                <strong>Gullet:</strong> {order.gulletWidth || 'N/A'}
                                            </span>
                                            <span className="text-[12px]">
                                                <strong>Bar Angle:</strong> {order.barAngle || 'N/A'}°
                                            </span>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="flex flex-col gap-1">
                                            <span className="text-[12px]">
                                                <strong>Seat:</strong> {order.saddleSpecs?.seatSize || 'N/A'}"
                                            </span>
                                        </div>
                                    </td>
                                    <td>
                                        <span className="text-[13px]">
                                            {formatLocation(order.shippingAddress)}
                                        </span>
                                    </td>
                                    <td>
                                        <span className={getStatusBadgeClass(displayStatus)}>
                                            {getStatusLabel(displayStatus, isCactusAdmin)}
                                        </span>
                                    </td>
                                    <td className="text-gray-500 text-[13px]">
                                        {dayjs.unix(Number(order.createdAt)).format('MMMM D, YYYY [at] h:mm A')}
                                    </td>
                                    <td onClick={(e) => e.stopPropagation()}>
                                        <div className="flex items-center gap-2">
                                            <button
                                                onClick={() => onViewOrder(order)}
                                                className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
                                                title="View Details"
                                            >
                                                <FiEye size={18} className="text-gray-600" />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default OrdersTable
